// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2yta6","header":"PatientQuestionnaire_header__1srTX","info":"PatientQuestionnaire_info__2pj0q"};